module.exports = __webpack_public_path__ + "static/media/logo-gold.32f378b1.svg";